import {
  Avatar,
  Button,
  Flex,
  Skeleton,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { Profile } from "iconsax-react";
import { useTranslation } from "react-i18next";
import { IProduct } from "../../../interfaces/Products/IProductDetail";
import { client_selected } from "../../../client";
import { IColor } from "../../../utils/selectColors";
import { CardBoxShadow, TagCapsules } from "../../../components";
import {
  tradutorCategory,
  tradutorSubcategory,
} from "../../../utils/SubCategorys";
import { convertRecurrencyType } from "../../../utils/convertRecurrencyType";
import { ERecurrencyType } from "../../../interfaces/MyPlans";

interface IProps {
  product?: IProduct;
  isLoading?: boolean;
}

export default function HeaderItem({ product, isLoading }: IProps) {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const name = product?.partner?.name || client_selected.name;
  const title = product?.title || "????";
  const certificate = !!product?.analyst_certificate_nr
    ? t("marketplace.detalhe.CNPI", {
        CNPI: product?.analyst_certificate_nr,
      })
    : null;
  const isGenial = client_selected.name === "Genial";
  const analyst = product?.analyst_user?.name || "----";
  const recurrency_type =
    product?.plans?.[0]?.recurrency_type || ERecurrencyType.MONTHLY;
  return (
    <CardBoxShadow flex={2}>
      <Flex
        w="100%"
        gap="16px"
        align="center"
        wrap={{ base: "wrap", 500: "nowrap" }}
        p="6px 16px"
      >
        {!isGenial ? (
          isLoading ? (
            <Skeleton height={80} mb="xl" width={80} />
          ) : (
            <Avatar
              component="span"
              variant="outline"
              size={80}
              radius={8}
              src={product?.icon}
              alt="Nome do parceiro"
              bg={theme.colors.basic[0]}
              sx={{
                border: "1px solid",
                borderColor: theme.colors.basic[2],

                img: {
                  objectFit: "cover",
                },
              }}
            >
              <Profile color={theme.colors.basic[5]} size={50} />
            </Avatar>
          )
        ) : null}

        <Flex
          justify="space-between"
          direction="column"
          h="fit-content"
          gap={"4px"}
        >
          {isLoading ? (
            <Skeleton height={25} width={100} mb={4} />
          ) : (
            <Flex gap="8px" wrap={"wrap"}>
              <Text
                bg={theme.colors.basic[1]}
                tt="uppercase"
                fw={700}
                size={12}
                lh="25px"
                color="basic.4"
                style={{
                  padding: "4px 8px",
                  width: "fit-content",
                  borderRadius: "8px",
                }}
              >
                {name}
              </Text>
              {product?.category ? (
                <TagCapsules colorTag={IColor.orange} border>
                  {t(tradutorCategory(product?.category).title)}
                </TagCapsules>
              ) : null}
              {product?.subcategory ? (
                <TagCapsules colorTag={IColor.yellow} border>
                  {t(tradutorSubcategory(product?.subcategory).title)}
                </TagCapsules>
              ) : null}
              <TagCapsules colorTag={IColor.violet} border>
                {t(convertRecurrencyType(recurrency_type))}
              </TagCapsules>
            </Flex>
          )}
          <Flex align={"start"} wrap="wrap" direction={"column"} gap="2px">
            {isLoading ? (
              <>
                <Skeleton height={32} width={250} mb={4} />
                <Skeleton height={22} width={100} />
                <Skeleton height={22} width={100} />
              </>
            ) : (
              <>
                <Title
                  tt="uppercase"
                  fw={700}
                  fz={32}
                  lh="50px"
                  color={theme.colors.basic[5]}
                  mr="5px"
                >
                  {title}
                </Title>
                {isGenial && analyst ? (
                  <Text
                    span
                    fz={16}
                    lh="22px"
                    color={theme.colors.primary[0]}
                    fw={600}
                    w="fit-content"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {analyst}
                  </Text>
                ) : null}
                {!!certificate ? (
                  <Text
                    span
                    fz={16}
                    lh="22px"
                    color={theme.colors.basic[5]}
                    fw={400}
                    w="fit-content"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {certificate}
                  </Text>
                ) : null}
              </>
            )}
          </Flex>
        </Flex>
      </Flex>
    </CardBoxShadow>
  );
}
